export default "__VITE_PUBLIC_ASSET__5427db48__"